import React from 'react';
import Radium from 'radium';
import Autocomplete from 'react-google-autocomplete';

class AddressAutoComplete extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            type: 'geocode'
        }
    }

    cityOnly(evt) {

        if (evt.target.checked) {
            this.setState({
                type: 'geocode'
            })
        } else {
            this.setState({
                type: 'address'
            })
        }
        console.log(this.state.type)
    }
    render() {

        const rowBlockLeft = {
            textAlign: 'left',
            paddingBottom: '2px',
            boxSizing: 'border-box',
            overflow: 'auto',
            height: '40px',
            lineHeight: '40px',
            // For mobile
            '@media (max-width: 992px)': {
                display: 'block'

            },

            '@media print': {
                width: '20%',
                display: 'inline',
                fontSize: '10px',
            }
        }

        const rowInputLeft = {
            overflow: 'auto',
            fontSize: '15px',
            border: '1px solid grey',
            paddingLeft: '8px',
            textAlign: 'left',
            float: 'right',
            backgroundColor: 'transparent',
            boxSizing: 'border-box',
            width: '100%',
            // For mobile
            '@media (max-width: 992px)': {
                width: '100%',
                boxSizing: 'border-box',
            },

            '@media print': {
                width: '40%',
                display: 'inline',
                boxSizing: 'content-box',
                fontSize: '10px',

            }
        }

        const customerInfoRow = {
            marginTop: '10px',
            overflow: 'auto',
            display: 'block'
        }

        return (
            <div>
                <div style={customerInfoRow}>

                    <Autocomplete
                        style={rowInputLeft}
                        onPlaceSelected={(place) => {
                            //alert(place.address_components[3].long_name)
                            //console.log(place);
                            //let city = place.address_components[3].long_name;
                            //let state = place.address_components[6].short_name;
                            let address = place.formatted_address;
                            //console.log(place.geometry.location.lat((a=>{console.log('lat: ' + a)})))
                            //console.log(place.geometry.location.lng((a=>{console.log('lng: ' + a)})))
                            let lat = place.geometry.location.lat((a=>{return a}))
                            let lng = place.geometry.location.lng((a=>{return a}))
                            let geo = [lat, lng]
                            this.props.onChange(address, geo);
                        }}
                        types={[this.state.type]}
                        //types={['administrative_area_level_5']}

                        componentRestrictions={{ country: "UK" }}
                    />




                </div>
            </div>
        );
    }
}

AddressAutoComplete = Radium(AddressAutoComplete);
export default AddressAutoComplete;